module.exports = __webpack_public_path__ + "img/profile-bg7.f4ed7489.jpg";